import { ReactNode, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAdminPassword } from '../shared/authConfig';

interface AdminRouteProps {
    children: ReactNode;
}

/**
 * Protected route wrapper for admin pages.
 * Checks if admin-pass exists in localStorage.
 * If not, redirects to /melaba/login with the current path as redirect parameter.
 */
export default function AdminRoute({ children }: AdminRouteProps) {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const adminPass = getAdminPassword();

        if (!adminPass) {
            // Redirect to login with current path as redirect parameter
            navigate(`/melaba/login?redirect=${encodeURIComponent(location.pathname)}`);
        }
    }, [navigate, location.pathname]);

    // Check if admin pass exists
    const adminPass = getAdminPassword();

    if (!adminPass) {
        // Don't render anything while redirecting
        return null;
    }

    return <>{children}</>;
}
